(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tabs]').forEach(initTabs);
});

function initTabs(root) {
  const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
  const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

  function activateTab(next) {
    tabs.forEach((t) => {
      const selected = t === next;
      t.classList.toggle('is-active', selected);
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", () => activateTab(tab));

    tab.addEventListener("keydown", (e) => {
      const currentTab = e.currentTarget;
      const i = tabs.indexOf(currentTab);

      if(i === -1) return;

      let nextIndex = null;

      if(e.key === "ArrowRight" || e.key === "ArrowDown") {
        nextIndex = (i + 1) % tabs.length;
      }

      if(e.key === "ArrowLeft" || e.key === "ArrowUp") {
        nextIndex = (i - 1 + tabs.length) % tabs.length;
      }

      if(e.key === "Home") nextIndex = 0;
      if(e.key === "End") nextIndex = tabs.length - 1;

      if(nextIndex !== null) {
        e.preventDefault();
        
        const nextTab = tabs[nextIndex];
              nextTab.focus();

        activateTab(nextTab);
      }
    });
  });

  const initial = tabs.find(t => t.classList.contains('is-active')) || tabs[0];
  if (initial) activateTab(initial);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    const buyBlock = document.querySelector('.buy-buttons-block');
    const stickyATC = document.querySelector('.sticky-atc-wrapper');
    const stickyBuyButton = stickyATC?.querySelector(".add-to-cart-button");

    if (!buyBlock || !stickyATC) return;

    let lastScrollY = window.scrollY;

    const onScroll = () => {
      const rect = buyBlock.getBoundingClientRect();
      const isInViewport = rect.bottom > 80;
      const scrollingDown = window.scrollY > lastScrollY;

      if (scrollingDown && !isInViewport) {
        stickyATC.classList.add('is-visible');

        if(!stickyATC.classList.contains("been-focused")) {

          //Ensure focus is brought to ATC when first scrolled down
          stickyBuyButton.focus();
          stickyATC.classList.add("been-focused");
        }
      } else if (isInViewport) {
        stickyATC.classList.remove('is-visible');
      }

      lastScrollY = window.scrollY;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }); 

  } catch(e) { console.error(e); }
})();
})();
